import PaymentMedica from "./PaymentMedica";
export default PaymentMedica;
